export const ActionTypes = {
    REQUEST_INIT : "REQUEST_INIT",
    REQUEST_FAILURE : "REQUEST_FAILURE",
    DEFAULT_RETURN : 'DEFAULT_RETURN',
    POST_CRUD : "POST_CRUD",
    FETCH_FORM : "FETCH_FORM", 
    CHANGE_INPUT: "CHANGE_INPUT",
}

